import { ACTION_TERMS, GROUP_NOUNS } from 'modules/featureFlags/constants';
import { Actions } from 'modules/featureFlags/types';
import { WarningBanner } from 'ui/banner';

const { org, project } = GROUP_NOUNS;

type FractionalBannerProps = {
  globalFraction: number;
  orgCount: number;
  projectCount: number;
};

const FractionalBanner = ({ globalFraction, orgCount, projectCount }: FractionalBannerProps) => {
  const orgText = `${orgCount} ${orgCount === 1 ? org.singular : org.plural}`;
  const projectText = `${projectCount} ${projectCount === 1 ? project.singular : project.plural}`;

  return (
    <WarningBanner
      title={`Default percent enabled will be set to ${Math.round(globalFraction * 100)}%`}
    >
      There will be {orgText} and {projectText} with individual overrides.
    </WarningBanner>
  );
};

export type ConfirmationBannerProps = {
  action?: Actions;
  isFractional: boolean;
  globalFraction?: number;
  orgIdFractions?: { [key: number]: number };
  projectIdFractions?: { [key: number]: number };
};

export const ConfirmationBanner = ({
  action = undefined,
  isFractional,
  globalFraction = 0,
  orgIdFractions = {},
  projectIdFractions = {},
}: ConfirmationBannerProps) => {
  if (isFractional) {
    const orgCount = Object.keys(orgIdFractions).length;
    const projectCount = Object.keys(projectIdFractions).length;

    return (
      <FractionalBanner
        globalFraction={globalFraction}
        orgCount={orgCount}
        projectCount={projectCount}
      />
    );
  }

  // return here to avoid errors when destructuring undefined if no action as key
  if (!action) return <></>;
  const { oppositeAction, pastTense } = ACTION_TERMS[action];
  const oppositeActionTerms = ACTION_TERMS[oppositeAction];

  return (
    <WarningBanner title={`This feature will be ${pastTense} globally`}>
      All orgs and projects will be impacted unless {oppositeActionTerms.pastTense}. See a breakdown
      below.
    </WarningBanner>
  );
};
